import React from 'react';
import SVG from 'react-inlinesvg';

import iconsMap from '../TopCardContainer/utils/loadNumberIcons';

interface Props {
  className: string;
  index: number;
  imageHeight: number;
}

export function NumberIcon({ className, index, imageHeight }: Props){
  const iconSrc = iconsMap.get(index + 1);

  return (
    <span style={{ height: imageHeight }} className={className}>
      {iconSrc ? <SVG src={iconSrc} /> : null}
    </span>
  )
}
